/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIBillFileSearchResult
 */
export interface APIBillFileSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIBillFileSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillFileSearchResult
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof APIBillFileSearchResult
     */
    fileName?: string;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResult
     */
    fileSize?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof APIBillFileSearchResult
     */
    storedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof APIBillFileSearchResult
     */
    lastModifiedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResult
     */
    billId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResult
     */
    contractId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof APIBillFileSearchResult
     */
    requestId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIBillFileSearchResult
     */
    requestCertificate?: string;
}

/**
 * Check if a given object implements the APIBillFileSearchResult interface.
 */
export function instanceOfAPIBillFileSearchResult(value: object): value is APIBillFileSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function APIBillFileSearchResultFromJSON(json: any): APIBillFileSearchResult {
    return APIBillFileSearchResultFromJSONTyped(json, false);
}

export function APIBillFileSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBillFileSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'key': json['key'] == null ? undefined : json['key'],
        'fileName': json['file_name'] == null ? undefined : json['file_name'],
        'fileSize': json['file_size'] == null ? undefined : json['file_size'],
        'storedAt': json['stored_at'] == null ? undefined : (new Date(json['stored_at'])),
        'lastModifiedAt': json['last_modified_at'] == null ? undefined : (new Date(json['last_modified_at'])),
        'billId': json['bill_id'] == null ? undefined : json['bill_id'],
        'contractId': json['contract_id'] == null ? undefined : json['contract_id'],
        'requestId': json['request_id'] == null ? undefined : json['request_id'],
        'requestCertificate': json['request_certificate'] == null ? undefined : json['request_certificate'],
    };
}

export function APIBillFileSearchResultToJSON(value?: APIBillFileSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'key': value['key'],
        'file_name': value['fileName'],
        'file_size': value['fileSize'],
        'stored_at': value['storedAt'] == null ? undefined : ((value['storedAt'] as any).toISOString()),
        'last_modified_at': value['lastModifiedAt'] == null ? undefined : ((value['lastModifiedAt'] as any).toISOString()),
        'bill_id': value['billId'],
        'contract_id': value['contractId'],
        'request_id': value['requestId'],
        'request_certificate': value['requestCertificate'],
    };
}

